import {Reducers} from './dataEnum';

// debug
export const GET_SETUP = `${Reducers.DEBUG_STORE}/GET_SETUP`;
export const INIT_VALUE = `${Reducers.DEBUG_STORE}/INIT_VALUE`;
export const UPDATE_STARTING_VOLUME = `${Reducers.DEBUG_STORE}/UPDATE_STARTING_VOLUME`;
export const UPDATE_STARTING_CONCENTRATION = `${Reducers.DEBUG_STORE}/UPDATE_STARTING_CONCENTRATION`;
export const UPDATE_FINAL_VOLUME = `${Reducers.DEBUG_STORE}/UPDATE_FINAL_VOLUME`;
export const UPDATE_FINAL_CONCENTRATION = `${Reducers.DEBUG_STORE}/UPDATE_FINAL_CONCENTRATION`;
export const UPDATE_VOLUME_TO_START_AT = `${Reducers.DEBUG_STORE}/UPDATE_VOLUME_TO_START_AT`;
export const UPDATE_DIAFILTRATION_MODE = `${Reducers.DEBUG_STORE}/UPDATE_DIAFILTRATION_MODE`;
export const UPDATE_BUFER_VOLUME_TO_USE = `${Reducers.DEBUG_STORE}/UPDATE_BUFER_VOLUME_TO_USE`;
export const UPDATE_CURRENT_BUFFER = `${Reducers.DEBUG_STORE}/UPDATE_CURRENT_BUFFER`;

export const RUN_PROTEIN_CONCENTRATOR = `${Reducers.DEBUG_STORE}/RUN_PROTEIN_CONCENTRATOR`;
export const RUN_PRIMING_MODE = `${Reducers.DEBUG_STORE}/RUN_PRIMING_MODE`;
export const RUN_CONCENTRATING_MODE = `${Reducers.DEBUG_STORE}/RUN_CONCENTRATING_MODE`;
export const RUN_DIAFILTRATING_MODE = `${Reducers.DEBUG_STORE}/RUN_DIAFILTRATING_MODE`;

export const STOP_PROTEIN_CONCENTRATOR = `${Reducers.DEBUG_STORE}/STOP_PROTEIN_CONCENTRATOR`;
export const PAUSE_PROTEIN_CONCENTRATOR = `${Reducers.DEBUG_STORE}/PAUSE_PROTEIN_CONCENTRATOR`;

// ADVANCE SETTING
export const UPDATE_DIAPHRAGM_VACUUM_PRESSURE = `${Reducers.DEBUG_STORE}/UPDATE_DIAPHRAGM_VACUUM_PRESSURE`;
export const UPDATE_DIAPHRAGM_PRESSURE = `${Reducers.DEBUG_STORE}/UPDATE_DIAPHRAGM_PRESSURE`;
export const UPDATE_DIAPHRAGM_TIMING = `${Reducers.DEBUG_STORE}/UPDATE_DIAPHRAGM_TIMING`;
export const UPDATE_VALVE_TIMING = `${Reducers.DEBUG_STORE}/UPDATE_VALVE_TIMING`;
export const UPDATE_SHOW_WARNING = `${Reducers.DEBUG_STORE}/UPDATE_SHOW_WARNING`;
export const AUTO_CALIBRATE = `${Reducers.DEBUG_STORE}/AUTO_CALIBRATE`;
export const RESET_TO_DEFAULT = `${Reducers.DEBUG_STORE}/RESET_TO_DEFAULT`;

// SETUP EXT
export const UPDATE_OPERATING_PRESURE = `${Reducers.DEBUG_STORE}/UPDATE_OPERATING_PRESURE`;
export const UPDATE_RECOVERY_OF_LIQUID = `${Reducers.DEBUG_STORE}/UPDATE_RECOVERY_OF_LIQUID`;
export const UPDATE_FLOW_RATE = `${Reducers.DEBUG_STORE}/UPDATE_FLOW_RATE`;
export const UPDATE_PC_STATE = `${Reducers.DEBUG_STORE}/UPDATE_PC_STATE`;

// status progress Bar
export const UPDATE_PERCENTAGE_PROGRESS_BAR = `${Reducers.DEBUG_STORE}/UPDATE_PROGRESS_BAR`;
export const UPDATE_ESTIMATE_TIME = `${Reducers.DEBUG_STORE}/UPDATE_ESTIMATE_TIME_REMAINING`;
export const UPDATE_PROGRESSBAR_STATUS = `${Reducers.DEBUG_STORE}/UPDATE_PROGRESSBAR_STATUS`;

// status
export const GET_STATUS = `${Reducers.DEBUG_STORE}/GET_STATUS`;
export const UPDATE_STATUS = `${Reducers.DEBUG_STORE}/UPDATE_STATUS`;

export const GET_OTHER_INFO = `${Reducers.DEBUG_STORE}/GET_OTHER_INFO`;
// slider current volume
export const UPDATE_CURRENT_VOLUME = `${Reducers.DEBUG_STORE}/UPDATE_CURRENT_VOLUME`;
export const UPDATE_DUMMY_BUFFER = `${Reducers.DEBUG_STORE}/UPDATE_DUMMY_BUFFER`;

export const UPDATE_STOPPING_FROM_BUTTON = `${Reducers.DEBUG_STORE}/UPDATE_STOPPING_FROM_BUTTON`;

export const UPDATE_ACTIVE_MENU = `${Reducers.DEBUG_STORE}/UPDATE_ACTIVE_MENU`;

// EXPLORER PAGE
export const UPDATE_PROFILE_NAME = `${Reducers.DEBUG_STORE}/UPDATE_PROFILE_NAME`;
export const UPDATE_PROFILE_LIST = `${Reducers.DEBUG_STORE}/UPDATE_PROFILE_LIST`;
export const PROFILE_SELECTED = `${Reducers.DEBUG_STORE}/PROFILE_SELECTED`;
export const PROFILE_SETTING_EXPLORER = `${Reducers.DEBUG_STORE}/PROFILE_SETTING_EXPLORER`;
export const UPDATE_ALL_VALUE = `${Reducers.DEBUG_STORE}/UPDATE_ALL_VALUE`;
export const UPDATE_SHOW_PROFILE = `${Reducers.DEBUG_STORE}/UPDATE_SHOW_PROFILE`;
export const UPDATE_LAST_PROFILE_ID_VIEW = `${Reducers.DEBUG_STORE}/UPDATE_LAST_PROFILE_ID_VIEW`;

// alert
export const SHOW_ALERT = `${Reducers.DEBUG_STORE}/SHOW_ALERT`;
// HARDWARE VALUE
export const HARDWARE_VALUE = `${Reducers.DEBUG_STORE}/HARDWARE_VALUE`;
export const SERIAL_CONNECT = `${Reducers.DEBUG_STORE}/SERIAL_CONNECT`;

// message
export const ERROR_MESSAGE = `${Reducers.DEBUG_STORE}/ERROR_MESSAGE`;
export const SUCCESS_MESSAGE = `${Reducers.DEBUG_STORE}/SUCCESS_MESSAGE`;
export const FAILURE_MESSAGE = `${Reducers.DEBUG_STORE}/FAILURE_MESSAGE`;
export const WARNING_MESSAGE = `${Reducers.DEBUG_STORE}/WARNING_MESSAGE`;
export const CLEAR_MESSAGE = `${Reducers.DEBUG_STORE}/CLEAR_MESSAGE`;

// sensor value
export const UPDATE_SENSOR_VALUE = `${Reducers.DEBUG_STORE}/UPDATE_SENSOR_VALUE`;

// sequence designer

export const START_SEQUENCE_DESIGNER = `${Reducers.DEBUG_STORE}/START_SEQUENCE_DESIGNER`;
export const STOP_SEQUENCE_DESIGNER = `${Reducers.DEBUG_STORE}/STOP_SEQUENCE_DESIGNER`;
export const PAUSE_SEQUENCE_DESIGNER = `${Reducers.DEBUG_STORE}/PAUSE_SEQUENCE_DESIGNER`;
export const RESUME_SEQUENCE_DESIGNER = `${Reducers.DEBUG_STORE}/RESUME_SEQUENCE_DESIGNER`;

// other info

export const UPDATE_OTHER_INFO = `${Reducers.DEBUG_STORE}/UPDATE_OTHER_INFO`;

export const RUN_PRIMING = `${Reducers.DEBUG_STORE}/RUN_PRIMING`;
export const RUN_CONCENTRATING = `${Reducers.DEBUG_STORE}/RUN_CONCENTRATING`;
export const RUN_DIAFILTRATING = `${Reducers.DEBUG_STORE}/RUN_DIAFILTRATING`;
